module.exports = __webpack_public_path__ + "img/soundPlayed.e7eea1fc.svg";